<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Medical Certificates</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="page-header-box">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="page-icon">
                      <i class="mdi mdi-clipboard-check-outline"></i>
                    </div>
                    <div class="ms-3">
                      <h4 class="page-title mb-1">Pending Approval</h4>
                      <p class="page-breadcrumb mb-0">
                        <span>Dashboard</span>
                        <i class="mdi mdi-chevron-right mx-1"></i>
                        <span>Certificates & Licenses</span>
                        <i class="mdi mdi-chevron-right mx-1"></i>
                        <span>Pending Approval</span>
                      </p>
                    </div>
                  </div>
                  <div class="header-stats-row d-flex">
                    <div class="header-stat-box">
                      <span class="stat-number">{{ numberFormat(totalBusiness) }}</span>
                      <span class="stat-text">PENDING APPROVAL</span>
                    </div>
                    <div class="header-stat-box stat-info">
                      <span class="stat-number">KES {{ numberFormat(totalAmount) }}</span>
                      <span class="stat-text">TOTAL VALUE</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarMedical/>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <!-- Card Header -->
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div>
                      <h5 class="card-title mb-1">
                        <i class="mdi mdi-clipboard-clock-outline me-2 text-info"></i>
                        Medical Certificates Pending Approval
                      </h5>
                      <p class="text-muted mb-0 small">Review and approve medical certificate applications</p>
                    </div>
                    <div class="header-search-box">
                      <div class="position-relative">
                        <i class="mdi mdi-magnify search-icon"></i>
                        <input
                            v-model="search"
                            type="text"
                            class="form-control search-input"
                            placeholder="Search by name, ID, bill number..."
                        >
                        <button v-if="search" @click="search = ''" class="btn-clear">
                          <i class="mdi mdi-close"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card Body -->
                <div class="card-body p-0">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-3 text-muted">Loading records...</p>
                  </div>

                  <!-- Empty State -->
                  <div v-if="pendingInvoicing.length < 1 && loading === false" class="text-center py-5">
                    <img src="assets/images/no-results.png" class="mb-4" style="height: 120px;" alt="No results"/>
                    <h5>No Pending Approvals</h5>
                    <p class="text-muted">All applications have been processed or no applications match your search.</p>
                    <button v-if="search" @click="search = ''" class="btn btn-outline-primary btn-sm">
                      <i class="mdi mdi-refresh me-1"></i> Clear Search
                    </button>
                  </div>

                  <!-- Data Table -->
                  <div v-if="pendingInvoicing.length > 0 && !loading" class="table-responsive">
                    <table class="table table-hover table-striped mb-0">
                      <thead class="table-light">
                      <tr>
                        <th>APPLICANT</th>
                        <th>INVOICE DETAILS</th>
                        <th>DATE INVOICED</th>
                        <th>INVOICED BY</th>
                        <th>AMOUNT</th>
                        <th>STATUS</th>
                        <th class="text-end">ACTIONS</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in pendingInvoicing" :key="index">
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-circle">
                              {{ getInitials(item.businessName) }}
                            </div>
                            <div class="ms-3">
                              <h6 class="mb-0 fw-semibold">{{ item.businessName }}</h6>
                              <small class="text-muted">
                                <i class="mdi mdi-card-account-details-outline me-1"></i>
                                ID: {{ item.businessID }}
                              </small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="fw-medium text-primary">{{ item.billNo }}</span>
                            <br>
                            <small class="text-muted">Medical Certificate</small>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ formatDate(item.dateCreated) }}</span>
                            <br>
                            <small class="text-muted">
                              {{ formattedTime(item.dateCreated) }} ({{ formatTimeAgo(item.dateCreated) }})
                            </small>
                          </div>
                        </td>
                        <td>
                          <span>{{ item.names }}</span>
                        </td>
                        <td>
                          <span class="fw-semibold">KES {{ numberFormat(item.billTotal) }}</span>
                        </td>
                        <td>
                            <span class="badge bg-info">
                              <i class="mdi mdi-clock-outline me-1"></i>
                              Pending Approval
                            </span>
                        </td>
                        <td>
                          <div class="d-flex justify-content-end gap-2">
                            <button
                                @click="getIndividualMedicalEntries(item)"
                                class="btn btn-sm btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target=".receipting-modal"
                                title="Review & Approve"
                            >
                              <i class="mdi mdi-clipboard-check-outline me-1"></i>
                              Review
                            </button>
                            <button
                                @click="printBill(item.billNo)"
                                class="btn btn-sm btn-outline-success"
                                title="Print Invoice"
                            >
                              <i class="mdi mdi-printer-outline"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Table Footer -->
                  <div v-if="!loading && pendingInvoicing.length > 0" class="card-footer bg-light border-top d-flex justify-content-between align-items-center">
                    <span class="text-muted">
                      Showing <strong>{{ pendingInvoicing.length }}</strong> pending approvals
                    </span>
                    <div>
                      <span class="me-3">
                        <i class="mdi mdi-file-document-multiple-outline me-1"></i>
                        {{ numberFormat(totalBusiness) }} Total
                      </span>
                      <span class="text-info fw-semibold">
                        <i class="mdi mdi-cash me-1"></i>
                        KES {{ numberFormat(totalAmount) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Review & Approval Modal -->
      <div class="modal fade receipting-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header modal-header-white">
              <div class="d-flex align-items-center">
                <div class="modal-header-icon">
                  <i class="mdi mdi-clipboard-check-outline"></i>
                </div>
                <div class="ms-3">
                  <h5 class="modal-title mb-0">Medical Certificate Review</h5>
                  <small class="text-muted">{{ individual.individualNames }}</small>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span class="badge bg-info me-3">Pending Approval</span>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
            </div>

            <div class="modal-body">
              <!-- Timeline -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-timeline-clock-outline me-2"></i>
                  Processing Timeline
                </h6>
                <div class="timeline-row">
                  <div class="timeline-step completed">
                    <div class="timeline-dot">
                      <i class="mdi mdi-check"></i>
                    </div>
                    <div class="timeline-label">Invoicing</div>
                    <div class="timeline-date">{{ formatDate(entriesMedical.dateCreated) }}</div>
                  </div>
                  <div class="timeline-line"></div>
                  <div class="timeline-step completed">
                    <div class="timeline-dot">
                      <i class="mdi mdi-check"></i>
                    </div>
                    <div class="timeline-label">Payment</div>
                    <div class="timeline-date">Completed</div>
                  </div>
                  <div class="timeline-line"></div>
                  <div class="timeline-step active">
                    <div class="timeline-dot">
                      <i class="mdi mdi-clock-outline"></i>
                    </div>
                    <div class="timeline-label">Approval</div>
                    <div class="timeline-date">Pending</div>
                  </div>
                </div>
              </div>

              <!-- Individual Details -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-account-outline me-2"></i>
                  Individual Details
                </h6>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">FULL NAMES</label>
                    <p class="mb-0 fw-medium">{{ individual.individualNames || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">ID NUMBER</label>
                    <p class="mb-0 fw-medium">{{ individual.individualD || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">PHONE</label>
                    <p class="mb-0 fw-medium">{{ individual.phoneNumber || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">EMAIL</label>
                    <p class="mb-0 fw-medium">{{ individual.email || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">SUB COUNTY</label>
                    <p class="mb-0 fw-medium">{{ individual.subCountyName || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">WARD</label>
                    <p class="mb-0 fw-medium">{{ individual.wardName || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">JOB TITLE</label>
                    <p class="mb-0 fw-medium">{{ individual.jobTitle || 'N/A' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">DATE REGISTERED</label>
                    <p class="mb-0 fw-medium">{{ formatDate(individual.dateCreated) }}</p>
                  </div>
                </div>
              </div>

              <!-- Certificate Details -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-certificate-outline me-2"></i>
                  Certificate Details
                </h6>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">BILL NUMBER</label>
                    <p class="mb-0 fw-medium font-monospace">{{ entriesMedical.billNo || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">DURATION</label>
                    <p class="mb-0 fw-medium">{{ entriesMedical.duration || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">VALID FROM</label>
                    <p class="mb-0 fw-medium">{{ formatDate(entriesMedical.startDate) }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">VALID UNTIL</label>
                    <p class="mb-0 fw-medium">{{ formatDate(entriesMedical.endDate) }}</p>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label text-muted small mb-1">BILL TOTAL</label>
                    <p class="mb-0 fw-semibold">KES {{ numberFormat(entriesMedical.billTotal) }}</p>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label text-muted small mb-1">PAID AMOUNT</label>
                    <p class="mb-0 fw-semibold text-success">KES {{ numberFormat(entriesMedical.receiptAmount) }}</p>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label text-muted small mb-1">BALANCE</label>
                    <p class="mb-0 fw-semibold" :class="entriesMedical.billBalance > 0 ? 'text-danger' : 'text-success'">
                      KES {{ numberFormat(entriesMedical.billBalance) }}
                    </p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">PAYMENT STATUS</label>
                    <p class="mb-0">
                      <span class="badge" :class="entriesMedical.status === 'Paid' ? 'bg-success' : 'bg-warning text-dark'">
                        {{ entriesMedical.status || 'Pending' }}
                      </span>
                    </p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">STAGE STATUS</label>
                    <p class="mb-0 fw-medium">{{ entriesMedical.stageStatus || '-' }}</p>
                  </div>
                </div>
              </div>

              <!-- Medical Tests Description -->
              <div class="section-block mb-4" v-if="entriesMedical.description">
                <h6 class="section-title">
                  <i class="mdi mdi-clipboard-text-outline me-2"></i>
                  Medical Tests / Findings
                </h6>
                <div class="findings-box">
                  {{ entriesMedical.description }}
                </div>
              </div>

              <!-- Approval Section -->
              <div class="section-block approval-section">
                <h6 class="section-title">
                  <i class="mdi mdi-check-decagram-outline me-2"></i>
                  Approval Decision
                </h6>
                <div class="mb-3">
                  <label class="form-label">Inspection Remarks <span class="text-danger">*</span></label>
                  <textarea
                      v-model="comments"
                      class="form-control"
                      rows="4"
                      placeholder="Enter your inspection remarks and observations..."
                  ></textarea>
                  <small class="text-muted">Provide detailed remarks about your inspection findings</small>
                </div>
                <div class="d-flex gap-3">
                  <button
                      data-bs-dismiss="modal"
                      @click="approveMedicalPermit('Approved')"
                      class="btn btn-success flex-grow-1"
                  >
                    <i class="mdi mdi-check-circle-outline me-1"></i>
                    Approve Certificate
                  </button>
                  <button
                      data-bs-dismiss="modal"
                      @click="approveMedicalPermit('Declined')"
                      class="btn btn-danger flex-grow-1"
                  >
                    <i class="mdi mdi-close-circle-outline me-1"></i>
                    Decline Application
                  </button>
                </div>
              </div>
            </div>

            <div class="modal-footer bg-light">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                <i class="mdi mdi-close me-1"></i> Cancel
              </button>
              <button @click="printBill(entriesMedical.billNo)" class="btn btn-outline-primary">
                <i class="mdi mdi-printer-outline me-1"></i> Print Invoice
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- SMS Modal -->
      <div class="modal fade SMS-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header modal-header-white">
              <div class="d-flex align-items-center">
                <div class="modal-header-icon icon-info">
                  <i class="mdi mdi-message-text-outline"></i>
                </div>
                <div class="ms-3">
                  <h5 class="modal-title mb-0">Resend Invoice SMS</h5>
                  <small class="text-muted">Send payment reminder</small>
                </div>
              </div>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="sms-info-card">
                <div class="mb-3">
                  <label class="form-label text-muted small mb-1">SEND TO</label>
                  <p class="mb-0 fw-semibold">{{ individual.phoneNumber }}</p>
                  <p class="mb-0 text-muted small">{{ individual.email }}</p>
                </div>
                <hr>
                <div class="mb-3">
                  <label class="form-label text-muted small mb-1">INVOICE NUMBER</label>
                  <p class="mb-0 fw-semibold text-primary font-monospace">{{ entriesMedical.billNo }}</p>
                </div>
                <div class="mb-0">
                  <label class="form-label text-muted small mb-1">DATE INVOICED</label>
                  <p class="mb-0">{{ formatDate(entriesMedical.dateCreated) }}, {{ formattedTime(entriesMedical.dateCreated) }}</p>
                </div>
              </div>
              <div class="alert alert-info mt-3 mb-0">
                <i class="mdi mdi-information-outline me-2"></i>
                A notification will be sent to the client via SMS containing payment details.
              </div>
            </div>
            <div class="modal-footer bg-light">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button @click="resendMessage()" data-bs-dismiss="modal" class="btn btn-primary">
                <i class="mdi mdi-send me-1"></i> Send SMS
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  <div class="rightbar-overlay"></div>

  </body>

</template>

<script>
/* eslint-disable */
import { defineComponent } from "vue";
import NavigationBar from "@/components/Navigation.vue";
import ToolBarMedical from "@/components/medical/ToolBarMedical.vue";
import { execute, biller, health } from "@/api";

export default {
  name: "PendingApprovalMedical",
  components: { ToolBarMedical, NavigationBar },

  data() {
    return {
      loading: true,
      comments: '',
      search: '',
      pendingInvoicing: [],
      entry: {
        statusID: null,
        businessID: null,
        businessName: null,
        billNo: null,
        billTotal: null,
        dateCreated: null,
        feeDescription: null,
        names: null,
        stageStatus: null,
      },
      totalBusiness: 0,
      totalAmount: 0,
      individual: {
        id: null,
        individualNames: null,
        individualD: null,
        phoneNumber: null,
        email: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        jobTitle: null,
        dateCreated: null
      },
      entriesMedical: {
        id: null,
        billNo: null,
        idNo: null,
        names: null,
        duration: null,
        billTotal: null,
        receiptAmount: null,
        billBalance: null,
        startDate: null,
        endDate: null,
        statusID: null,
        status: null,
        printable: null,
        issuingOfficer: null,
        designation: null,
        dateOfIssue: null,
        stageStatus: null,
        comments: null,
        incomeTypeId: null,
        feeID: null,
        subCountyName: null,
        wardName: null,
        dateCreated: null,
        subCountyID: null,
        wardID: null,
        code: null,
        brimsCode: null,
        fiscalYear: null,
        description: null
      },
      billDetail: {
        id: null,
        billNo: null,
        incomeTypeID: null,
        incomeTypeDescription: null,
        costCenterNo: null,
        accountNo: null,
        description: null,
        feeID: null,
        feeDescription: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        wardID: null,
        subCountyID: null,
        subCountyName: null,
        wardName: null,
        status: null,
        dateCreated: null,
        zone: null,
        departmentID: null,
        department: null,
        idNo: null,
        phoneNumber: null,
        names: null,
        customerPhoneNumber: null,
        category: null
      }
    }
  },

  mounted() {
    this.getPendingApprovalMedical();
    this.menuAccess();
  },

  watch: {
    search() {
      this.getPendingApprovalMedical();
    }
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Pending Approval Medical");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch((e) => console.error(e));
    },

    getInitials(name) {
      if (!name) return '?';
      const parts = name.split(' ');
      return parts.length >= 2
          ? (parts[0][0] + parts[1][0]).toUpperCase()
          : name.substring(0, 2).toUpperCase();
    },

    formatTimeAgo(dateString) {
      const currentDate = new Date();
      const date = new Date(dateString);
      const timeDifference = currentDate - date;
      const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

      if (daysDifference === 0) return 'Today';
      if (daysDifference === 1) return 'Yesterday';
      return `${daysDifference} Days Ago`;
    },

    formattedTime(originalTime) {
      const parsedTime = new Date(originalTime);
      return parsedTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const date = new Date(dateString);
      return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    getPendingApprovalMedical() {
      this.loading = true;
      this.pendingInvoicing = [];

      const data = new FormData();
      data.append("function", "getPendingApprovalMedical");
      data.append("keyword", this.search);
      data.append("statusID", "4");

      execute(data, health)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.pendingInvoicing = res.data.data.pendingInvoicing || [];
              this.totalBusiness = this.pendingInvoicing.length;
              this.totalAmount = this.pendingInvoicing.reduce((acc, cur) => {
                const amount = Number(cur.billTotal);
                return !isNaN(amount) ? acc + amount : acc;
              }, 0);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
          });
    },

    getIndividualMedicalEntries(item) {
      this.entry = item;
      this.comments = '';

      const data = new FormData();
      data.append("function", "getIndividualMedicalEntries");
      data.append("billNo", this.entry.billNo);

      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              this.individual = res.data.data.individual;
              this.entriesMedical = res.data.data.entriesMedical;

              this.billDetail = {
                ...this.billDetail,
                billNo: this.entriesMedical.billNo,
                detailAmount: this.entriesMedical.billTotal,
                billBalance: this.entriesMedical.billBalance,
                status: this.entriesMedical.status,
                dateCreated: this.entriesMedical.dateCreated,
                description: this.entriesMedical.description,
                names: this.entry.names
              };
            }
          })
          .catch((e) => console.error(e));
    },

    resendMessage() {
      const data = new FormData();
      data.append("function", "resendMessage");
      data.append("customerPhoneNumber", this.individual.phoneNumber);
      data.append("incomeTypePrefix", this.billDetail.incomeTypePrefix);
      data.append("billNo", this.entriesMedical.billNo);
      data.append("name", this.individual.individualNames);

      execute(data, biller)
          .then((res) => {
            alert(res.data.message);
          })
          .catch((e) => console.error(e));
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({ billNo: billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    approveMedicalPermit(stageStatus) {
      const data = new FormData();
      data.append("function", "approveMedicalPermit");
      data.append("comments", this.comments);
      data.append("billNo", this.entry.billNo);
      data.append("statusID", Number(this.entry.statusID) + 1);
      data.append("idNo", sessionStorage.getItem("idNo"));
      data.append("names", sessionStorage.getItem("names"));
      data.append("phoneNumber", sessionStorage.getItem("phoneNumber"));
      data.append("balanceAmount", this.entriesMedical.billBalance);
      data.append("stageStatus", stageStatus);
      data.append("ownerPhone", this.individual.phoneNumber);

      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              this.comments = '';
              this.getPendingApprovalMedical();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => console.error(e));
    }
  }
}
</script>

<style scoped>
/* Page Header */
.page-header-box {
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.page-icon {
  width: 50px;
  height: 50px;
  background: #2a3f54;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #2a3f54;
}

.page-breadcrumb {
  font-size: 13px;
  color: #6c757d;
}

.page-breadcrumb span:last-child {
  color: #2a3f54;
  font-weight: 500;
}

.header-stats-row {
  gap: 12px;
}

.header-stat-box {
  background: #2a3f54;
  border-radius: 8px;
  padding: 12px 20px;
  text-align: center;
  min-width: 140px;
}

.header-stat-box.stat-info {
  background: #17a2b8;
}

.stat-number {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.stat-text {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 0.5px;
  margin-top: 2px;
}

/* Search Box */
.header-search-box {
  min-width: 300px;
}

.header-search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  font-size: 18px;
}

.header-search-box .search-input {
  padding-left: 40px;
  padding-right: 36px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  height: 40px;
}

.header-search-box .search-input:focus {
  border-color: #2a3f54;
  box-shadow: 0 0 0 2px rgba(42, 63, 84, 0.1);
}

.header-search-box .btn-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #adb5bd;
  cursor: pointer;
  padding: 4px;
}

.header-search-box .btn-clear:hover {
  color: #495057;
}

/* Avatar Circle */
.avatar-circle {
  width: 40px;
  height: 40px;
  background: #2a3f54;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
}

/* Table Styling */
.table thead th {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #495057;
  border-bottom: 2px solid #e9ecef;
  padding: 12px 16px;
  white-space: nowrap;
}

.table tbody td {
  padding: 14px 16px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f3f5;
}

.table tbody tr:hover {
  background: #f8f9fa;
}

/* Modal Styling */
.modal-header-white {
  background: #fff;
  color: #2a3f54;
  border-bottom: 1px solid #e9ecef;
  padding: 16px 20px;
}

.modal-header-icon {
  width: 44px;
  height: 44px;
  background: #2a3f54;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
}

.modal-header-icon.icon-info {
  background: #17a2b8;
}

/* Section Blocks */
.section-block {
  padding-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
}

.section-block:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #2a3f54;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #2a3f54;
}

/* Timeline */
.timeline-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 20px;
}

.timeline-step {
  text-align: center;
  flex: 1;
  position: relative;
}

.timeline-dot {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
  color: #adb5bd;
  font-size: 16px;
}

.timeline-step.completed .timeline-dot {
  background: #28a745;
  color: #fff;
}

.timeline-step.active .timeline-dot {
  background: #17a2b8;
  color: #fff;
}

.timeline-label {
  font-weight: 600;
  font-size: 13px;
  color: #495057;
}

.timeline-date {
  font-size: 12px;
  color: #adb5bd;
}

.timeline-line {
  flex: 0 0 60px;
  height: 2px;
  background: #e9ecef;
  margin-top: 18px;
}

/* Findings Box */
.findings-box {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px 16px;
  border-left: 3px solid #2a3f54;
  font-size: 14px;
  color: #495057;
}

/* Approval Section */
.approval-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
  border: none;
}

.approval-section .section-title {
  color: #2a3f54;
}

/* SMS Info Card */
.sms-info-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

/* Card Footer */
.card-footer {
  padding: 12px 16px;
  font-size: 13px;
}

/* Responsive */
@media (max-width: 992px) {
  .header-search-box {
    min-width: 100%;
    margin-top: 16px;
  }

  .header-stats-row {
    width: 100%;
    justify-content: flex-end;
    margin-top: 16px;
  }
}

@media (max-width: 768px) {
  .page-header-box {
    padding: 16px;
  }

  .page-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .page-title {
    font-size: 16px;
  }

  .header-stat-box {
    padding: 10px 16px;
    min-width: 120px;
  }

  .stat-number {
    font-size: 16px;
  }

  .timeline-row {
    padding: 0;
  }

  .timeline-line {
    flex: 0 0 30px;
  }

  .approval-section .d-flex {
    flex-direction: column;
  }
}
</style>